{
    "features-debit-card-discounts": {
        "meta": {
            "title": "Descuentos - MAJORITY",
            "description": "¡Ahorra cuando gastes en restaurantes locales, supermercados y muchos lugares más en tu comunidad!"
        },
        "hero": {
            "title": "Descuentos MAJORITY",
            "body": "Paga con orgullo y ahorra en cualquiera de nuestros socios de descuentos locales. ¡Gasta menos en alimentos, restaurantes y más!"
        }
    }
}